import { Element } from "./element.js";
import { Shadow } from "./shadow.js";
import { Slotable } from "./slotable.js";
/**
 * @public
 */
export var Slot;
(function (Slot) {
    function isSlot(value) {
        return Element.isElement(value) && value.name === "slot";
    }
    Slot.isSlot = isSlot;
    /**
     * {@link https://dom.spec.whatwg.org/#slot-name}
     */
    function name(slot) {
        return slot
            .attribute("name")
            .map((name) => name.value)
            .getOr("");
    }
    Slot.name = name;
    /**
     * {@link https://dom.spec.whatwg.org/#find-slotables}
     */
    function* findSlotables(slot) {
        const root = slot.root();
        if (Shadow.isShadow(root)) {
            for (const host of root.host) {
                for (const child of host.children()) {
                    if (Slotable.isSlotable(child) &&
                        child.assignedSlot().includes(slot)) {
                        yield child;
                    }
                }
            }
        }
    }
    Slot.findSlotables = findSlotables;
})(Slot || (Slot = {}));
//# sourceMappingURL=slot.js.map